import { useState, useEffect } from 'react';
import { get } from '../utils/api';

const useSettings = () => {
  const [settings, setSettings] = useState({});
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await get('/settings');
        const settingsMap = response.reduce((acc, setting) => {
          acc[setting.setting_key] = {
            value: setting.value,
            translations: setting.translations,
          };
          return acc;
        }, {});
        setSettings(settingsMap);
        setLoading(false);
      } catch (err) {
        console.error('[useSettings] Error fetching settings:', err);
        setError(err);
        setLoading(false);
      }
    };

    fetchSettings();
  }, []);

  return { settings, error, loading };
};

export default useSettings;